import { render, staticRenderFns } from "./media-downloader.vue?vue&type=template&id=4aff982d&scoped=true"
import script from "./media-downloader.vue?vue&type=script&lang=js"
export * from "./media-downloader.vue?vue&type=script&lang=js"
import style0 from "./media-downloader.vue?vue&type=style&index=0&id=4aff982d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aff982d",
  null
  
)

export default component.exports